import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import moment from 'moment';
// @ts-ignore – no type declarations for this bundled file
import 'moment/min/locales';
moment.locale('en');

function hasAuthErrorInUrl(): boolean {
  return (
    (window.location.hash.includes('error') ||
    window.location.search.includes('error')) && window.location.href.includes('impersonate')
  );
}

if (environment.production) {
  enableProdMode();
}

if (hasAuthErrorInUrl()) {
  console.log('Auth error detected before bootstrap, redirecting to logoutRedirectURI');
  window.location.replace(environment.logoutRedirectURI);
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
